<template>
  <div class="pt-4 license">
    <section class="section">
      <h3><u>Retrofit</u></h3>
      <table class="table">
        <tr>
          <td class="content">
            <div>
              <p>
                https://github.com/square/retrofit
              </p>
              <p>
                Copyright 2013 Sqaure, Inc.
              </p>
              <p>
                Licensed under the Apache License, Version 2.0 (the "License");
                you may not use this file except in compliance with the License.
                You may obtain a copy of the License at
              </p>
              <p>
                http://www.apache.org/licenses/LICENSE-2.0
              </p>
              <p>
                Unless required by applicable law or agreed to in writing,
                software distributed under the License is distributed on an "AS
                IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
                express or implied. See the License for the specific language
                governing permissions and limitations under the License.
              </p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section">
      <h3><u>ButterKnife</u></h3>
      <table class="table">
        <tr>
          <td class="content">
            <div>
              <p>
                https://github.com/JakeWharton/butterknife
              </p>
              <p>
                Copyright 2013 John Wharton
              </p>
              <p>
                Licensed under the Apache License, Version 2.0 (the "License");
                you may not use this file except in compliance with the License.
                You may obtain a copy of the License at
              </p>
              <p>
                http://www.apache.org/licenses/LICENSE-2.0
              </p>
              <p>
                Unless required by applicable law or agreed to in writing,
                software distributed under the License is distributed on an "AS
                IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
                express or implied. See the License for the specific language
                governing permissions and limitations under the License.
              </p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section">
      <h3><u>Lottie</u></h3>
      <table class="table">
        <tr>
          <td class="content">
            <div>
              <p>
                Copyright 2018 Airbnb, Inc.
              </p>
              <p>
                Licensed under the Apache License, Version 2.0 (the "License");
                you may not use this file except in compliance with the License.
                You may obtain a copy of the License at
              </p>
              <p>
                http://www.apache.org/licenses/LICENSE-2.0
              </p>
              <p>
                Unless required by applicable law or agreed to in writing,
                software distributed under the License is distributed on an "AS
                IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
                express or implied. See the License for the specific language
                governing permissions and limitations under the License.
              </p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section">
      <h3><u>LottieFiles</u></h3>
      <table class="table">
        <tr>
          <td class="content">
            <div>
              <p>
                https://lottiefiles.com/
              </p>
              <p>
                All the public files available in LottieFiles are distributed
                under Creative Commons (CC) Attribution (BY) unless stated
                otherwise.
              </p>
              <p>
                Animaion Used: https://lottiefiles.com/1342-location
                <br />
                Author: https://lottiefiles.com/edwinnollen <br />
                Animation Used : https://lottiefiles.com/433-checked-done <br />
                Author : https://lottiefiles.com/433-checked-done
              </p>
            </div>
          </td>
        </tr>
      </table>
    </section>

    <section class="section">
      <h3><u>Gson</u></h3>
      <table class="table">
        <tr>
          <td class="content">
            <div>
              <p>
                https://github.com/JakeWharton/butterknife
              </p>
              <p>
                Copyright 2008 Google Inc.
              </p>
              <p>
                Licensed under the Apache License, Version 2.0 (the "License");
                you may not use this file except in compliance with the License.
              </p>
            </div>
          </td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: "appLicense"
};
</script>

<style scoped>
.license {
  font-family: Arial, Helvetica, sans-serif !important;
}

.table {
  border: 1px solid #000;
}

.content {
  user-select: text;
  display: block;
  margin: 0px;
  overflow-wrap: break-word;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  font-size: 14px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-weight: 400;
  letter-spacing: normal;
  text-align: left;
  text-indent: 0px;
  text-transform: none;
}

.section {
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/appLicense.vue